module.exports = __webpack_public_path__ + "img/quiz_night_creation_management.a8f89df0.png";